import { render } from "./Queries.vue?vue&type=template&id=ecaf3cce&scoped=true"
import script from "./Queries.vue?vue&type=script&lang=js"
export * from "./Queries.vue?vue&type=script&lang=js"

import "./Queries.vue?vue&type=style&index=0&id=ecaf3cce&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecaf3cce"]])

export default __exports__